<div
  class="page-content"
  [class.page-content--admin-mode]="adminMode"
  [class.is-scrolling]="isScrolling"
>
  @let header = globalDataService.config().header;
  <app-header
    [styles]="header.data.styles"
    [logoDisplay]="header.data.logo.display"
    [logoSrc]="header.data.logo.src_data"
    [logoRedirect]="header.data.logo.redirect"
    [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
  ></app-header>
  <section class="container">
    <div class="maintenance">
      <mat-icon class="material-symbols-outlined">warning</mat-icon>
      <h1 class="maintenance__title h5">Update in Progress</h1>
      <p class="maintenance__text body2">
        This site is undergoing scheduled maintenance.<br /><br />
        We'll be back shortly.</p>
    </div>
  </section>
  @let footer = globalDataService.config().footer;
  <app-footer
    [styles]="footer.data.styles"
    [address]="footer.data.address"
    [address_line_2]="footer.data.address_line_2"
    [phone]="footer.data.phone"
    [email]="footer.data.email"
    [facebook]="footer.data.facebook"
    [twitter]="footer.data.twitter"
    [instagram]="footer.data.instagram"
    [youtube]="footer.data.youtube"
    [linkedin]="footer.data.linkedin"
    [copyright_text]="footer.data.copyright_text"
    [link_1_text]="footer.data.link_1_text"
    [link_1_url]="footer.data.link_1_url"
    [link_2_text]="footer.data.link_2_text"
    [link_2_url]="footer.data.link_2_url"
    [link_3_text]="footer.data.link_3_text"
    [link_3_url]="footer.data.link_3_url"
  ></app-footer>
</div>
